import _ from 'lodash'

export const getFlatterenedFieldErrors = (error) => {
  const flatternedFieldErrors = []

  // If fieldMessages exists, flattern using a simple depth-first search
  if (error && error.detail && error.detail.fieldMessages) {
    const stack = [error.detail.fieldMessages]
    while (stack.length > 0) {
      const next = stack.pop()

      // Delete any 'all' key as we only wish to include field errors
      if (_.isPlainObject(next)) {
        delete next.all
      }

      // If we have an error, add the errors to the list, otherwise continue to search for errors
      if (_.isArray(next)) {
        Array.prototype.push.apply(flatternedFieldErrors, next)
      } else {
        Array.prototype.push.apply(stack, Object.values(next))
      }
    }
  }

  return flatternedFieldErrors
}



/** WEBPACK FOOTER **
 ** ./src/utils/errors/errors.js
 **/